(() => {
    const chatInitializers = {
        livechat:`
function connectLiveChat() {
    window.__lc = window.__lc || {};
    window.__lc.license = 11755086;
    ;(function(n,t,c){function i(n){return e._h?e._h.apply(null,n):e._q.push(n)}var e={_q:[],_h:null,_v:"2.0",on:function(){i(["on",c.call(arguments)])},once:function(){i(["once",c.call(arguments)])},off:function(){i(["off",c.call(arguments)])},get:function(){if(!e._h)throw new Error("[LiveChatWidget] You can't use getters before load.");return i(["get",c.call(arguments)])},call:function(){i(["call",c.call(arguments)])},init:function(){var n=t.createElement("script");n.async=!0,n.type="text/javascript",n.src="https://cdn.livechatinc.com/tracking.js",t.head.appendChild(n)}};!n.__lc.asyncInit&&e.init(),n.LiveChatWidget=n.LiveChatWidget||e}(window,document,[].slice))
}
connectLiveChat();
`,
        zohoanswerbot: `
    let d=document;s=d.createElement("script"),s.type="text/javascript",s.id="zohodeskasapscript",s.defer=!0,s.nonce="{place_your_nonce_value_here}",s.src="https://desk.zoho.com/portal/api/web/asapApp/846539000047313346?orgId=809050985",t=d.getElementsByTagName("script")[0],t.parentNode.insertBefore(s,t),window.ZohoDeskAsapReady=function(s){var e=window.ZohoDeskAsap__asyncalls=window.ZohoDeskAsap__asyncalls||[];window.ZohoDeskAsapReadyStatus?(s&&e.push(s),e.forEach(s=>s&&s()),window.ZohoDeskAsap__asyncalls=null):s&&e.push(s)};
`,
        zohosalesiq: `
    window.$zoho=window.$zoho || {};$zoho.salesiq=$zoho.salesiq||{ready:function(){}};
    window.Dashboard.helpers.addScriptTag(
        "https://salesiq.zohopublic.com/widget?wc=siq7d823cf5c680aef1ada7e249258027d8",
        "zsiqscript"
    );
`
    };
    class ChatAssistantSelector {
        /**
         * @type {ApiService}
         * @private
         */
        _apiService;
        constructor(
            APIService
        ) {
            this._apiService = APIService;
        }
        async connect() {
            const setting = await this._apiService.Settings.fetchChatAssistant();
            const lsetting = setting.toLowerCase();
            if (lsetting === "none") {
                return console.log("chat assistant is disabled at the backend");
            }
            const script = chatInitializers[lsetting];
            if (!script) {
                return console.error(`Unknown or unsupported chat assistant: '${setting}'`);
            }
            console.log(`adding chat assistant: ${setting}`);
            window.Dashboard.helpers.addScriptTag(
                script,
                lsetting,
                true
            );
        }
    }
    angular.module("dashboard")
        .service("ChatAssistantSelector", [
            "APIService",
            ChatAssistantSelector
        ]);
})();
